import getFormType from './_form-type.js';

/**
 * GTM form interaction handling.
 */
export default function formStarts() {
	const interactedForms = new Set(); // To keep track of forms that have been interacted with

	/**
	 * Handles interactions with form elements and pushes data to the dataLayer.
	 * Adds special support for Gravity Forms.
	 *
	 * @param {Event} event - The DOM event triggered by interacting with a form element.
	 */
	const handleInteraction = (event) => {
	  const { form } = event.target;
	  if (!form) return; // Exit if the event target is not part of a form

	  const formIdOrName = form.id || form.name; // Use ID or name as the identifier

	  // Check if this form has already been interacted with
	  if (interactedForms.has(formIdOrName)) return;

	  // Mark this form as interacted
	  interactedForms.add(formIdOrName);

	  const formLocation = window.location.href; // Current URL
	  const formElement = event.target.name || 'Unnamed Element'; // Name of the form element, if available
	  let formName = form.name || form.id || 'Unnamed Form'; // Use name or id, fallback to 'Unnamed Form'

	  // Special handling for Gravity Forms
	  if (form.classList.contains('gform_wrapper')) {
			const titleElement = form.querySelector('.gform_title');
			if (titleElement) {
		  formName = titleElement.textContent || titleElement.innerText;
			}
	  }
	  window.dataLayer = window.dataLayer || [];
	  window.dataLayer.push({
			event: 'form_start',
			form_location: formLocation,
			form_element: formElement,
			form_name: formName,
			form_type: getFormType(form)
	  });
	};

	// Get all forms on the page
	const forms = document.querySelectorAll('form');

	// Attach a single event listener to each form
	forms.forEach((form) => {
	  form.addEventListener('input', handleInteraction); // for text inputs, textareas
	  form.addEventListener('change', handleInteraction); // for selects, radio buttons, checkboxes
	});
}
